import api from './api';

// ===== License Vendors =====
export const getVendors = (includeInactive = false) =>
  api.get(`/license-vendors${includeInactive ? '?includeInactive=true' : ''}`);

export const getVendorById = (id) =>
  api.get(`/license-vendors/${id}`);

export const createVendor = (data) =>
  api.post('/license-vendors', data);

export const updateVendor = (id, data) =>
  api.put(`/license-vendors/${id}`, data);

export const deleteVendor = (id) =>
  api.delete(`/license-vendors/${id}`);

// ===== License Products =====
export const getProducts = (vendorId = null, includeInactive = false) => {
  const params = new URLSearchParams();
  if (vendorId) params.append('vendorId', vendorId);
  if (includeInactive) params.append('includeInactive', 'true');
  const query = params.toString();
  return api.get(`/license-products${query ? '?' + query : ''}`);
};

export const getProductById = (id) =>
  api.get(`/license-products/${id}`);

export const getProductsByVendor = (vendorId) =>
  api.get(`/license-products/by-vendor/${vendorId}`);

export const createProduct = (data) =>
  api.post('/license-products', data);

export const updateProduct = (id, data) =>
  api.put(`/license-products/${id}`, data);

export const deleteProduct = (id) =>
  api.delete(`/license-products/${id}`);

// ===== License Assignments =====
export const getAssignments = (filters = {}) => {
  const params = new URLSearchParams();
  if (filters.employeeId) params.append('employeeId', filters.employeeId);
  if (filters.vendorId) params.append('vendorId', filters.vendorId);
  if (filters.productId) params.append('productId', filters.productId);
  if (filters.departmentId) params.append('departmentId', filters.departmentId);
  if (filters.includeRevoked) params.append('includeRevoked', 'true');
  const query = params.toString();
  return api.get(`/license-assignments${query ? '?' + query : ''}`);
};

export const getAssignmentById = (id) =>
  api.get(`/license-assignments/${id}`);

export const getMyAssignments = () =>
  api.get('/license-assignments/my');

export const getEmployeeAssignments = (employeeId, includeRevoked = false) =>
  api.get(`/license-assignments/employee/${employeeId}${includeRevoked ? '?includeRevoked=true' : ''}`);

export const getAssignmentHistory = (employeeId) =>
  api.get(`/license-assignments/history/${employeeId}`);

export const createAssignment = (data) =>
  api.post('/license-assignments', data);

export const updateAssignment = (id, data) =>
  api.put(`/license-assignments/${id}`, data);

export const revokeAssignment = (id, data) =>
  api.post(`/license-assignments/${id}/revoke`, data);

export const bulkAssign = (data) =>
  api.post('/license-assignments/bulk-assign', data);

// ===== Asset Reports =====
export const getAssetReport = (params = {}) => {
  const searchParams = new URLSearchParams();
  if (params.groupBy) searchParams.append('groupBy', params.groupBy);
  if (params.departmentId) searchParams.append('departmentId', params.departmentId);
  if (params.employeeId) searchParams.append('employeeId', params.employeeId);
  if (params.assetType) searchParams.append('assetType', params.assetType);
  if (params.categoryId) searchParams.append('categoryId', params.categoryId);
  if (params.vendorId) searchParams.append('vendorId', params.vendorId);
  if (params.productId) searchParams.append('productId', params.productId);
  if (params.includeRevoked) searchParams.append('includeRevoked', 'true');
  if (params.dateFrom) searchParams.append('dateFrom', params.dateFrom);
  if (params.dateTo) searchParams.append('dateTo', params.dateTo);
  const query = searchParams.toString();
  return api.get(`/reports/assets${query ? '?' + query : ''}`);
};

export default {
  // Vendors
  getVendors,
  getVendorById,
  createVendor,
  updateVendor,
  deleteVendor,
  // Products
  getProducts,
  getProductById,
  getProductsByVendor,
  createProduct,
  updateProduct,
  deleteProduct,
  // Assignments
  getAssignments,
  getAssignmentById,
  getMyAssignments,
  getEmployeeAssignments,
  getAssignmentHistory,
  createAssignment,
  updateAssignment,
  revokeAssignment,
  bulkAssign,
  // Reports
  getAssetReport
};

